"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTT007_Detail = void 0;
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const classes_1 = require("../../base/classes");
const layout_1 = require("../../base/layout");
const popup_1 = require("../../base/popup");
const action_1 = require("../../menu/action");
const DSTT007_Detail_Child_1 = require("./component/DSTT007_Detail_Child");
const functions_1 = require("./functions");
const DSTT007_DetailStyled = styled_components_1.default.div `
	width: 100%;
	${({ $isMobile }) => $isMobile && `padding: 20px;`}

	.video-area {
		border-radius: 12px;
		flex-shrink: 0;
		height: 284px;
		max-width: 500px;
		position: relative;
		overflow: hidden;
		width: 100%;

		video {
			background: var(--color-black, #010101);

			width: 100%;
			height: 100%;
			object-fit: contain;
			z-index: 1;
		}

		.txt {
			color: #ffffff;
			text-align: left;
			font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h4-font-size, 20px);
			line-height: var(--h4-line-height, 32px);
			letter-spacing: var(--h4-letter-spacing, -0.02em);
			font-weight: var(--h4-font-weight, 700);
			position: absolute;
			left: 22.83px;
			top: 14px;
		}
	}

	.loading {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.dst007-container {
		display: flex;
		flex-direction: row;
		gap: 24px;
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		height: 100%;

		.left-wrap {
			display: flex;
			flex-direction: column;
			gap: 24px;
			align-items: flex-end;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			flex: 1;
			width: 100%;

			.title-info {
				display: flex;
				flex-direction: column;
				gap: 24px;
				align-items: flex-start;
				justify-content: flex-start;
				align-self: stretch;
				flex-shrink: 0;
				position: relative;
				flex: 1;
			}

			.field-short {
				flex: 0;
			}

			.title-wrap {
				border-style: solid;
				border-color: var(--color-grey-c, #e6e8ed);
				border-width: 0px 0px 1px 0px;
				padding: 0px 0px 28px 0px;

				.fext-field {
					.dropdown {
						max-width: 184px;
					}
				}

				.dropdown {
					min-width: 157px;
				}
			}

			.file-wrap {
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;

				.task-label {
					min-height: 50px;
				}
			}
		}

		.right-wrapper {
			max-width: 600px;
		}

		.file-container {
			background: var(--color-white, #ffffff);
			border-radius: 4px;
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px;
			padding: 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: flex-start;
			flex: 1;
			position: relative;
			overflow: hidden;
			flex-wrap: wrap;

			.user-name {
				background: var(--bg-bgw1, #f3f4f8);
				border-radius: 100px;
				padding: 4px 8px 4px 8px;
				display: flex;
				flex-direction: row;
				gap: 4px;
				align-items: center;
				justify-content: flex-start;
				flex-shrink: 0;
				position: relative;

				.name {
					color: var(--font-dgrey, #4d4d4d);
					text-align: left;
					font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
					font-size: var(--b5-font-size, 12px);
					line-height: var(--b5-line-height, 22px);
					letter-spacing: var(--b5-letter-spacing, -0.02em);
					font-weight: var(--b5-font-weight, 400);

					/* 성명(ID) — 아이디는 한 톤 연하게 */
					.idf {
						color: var(--color-grey-l, #83868a);
						margin-left: 1px;
					}
				}
			}
		}
	}

	.member-wrap {
		display: flex;
		flex-direction: column;
	}

	.task-label-btn {
		flex-direction: row;
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 20px;
	}

	/* 참여자 추가 · 엑셀 일괄 등록 */
	.member-buttons {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
	}

	${props => (props.$isMobile ? mobileStyles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.title-wrap {
		flex-direction: column;
		gap: 12px;
		.fext-field {
			flex-direction: column;
		}
	}

	.replay-info-wrap {
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		width: 100%;
	}

	.title-info {
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.file-wrap {
		flex-direction: column;
	}
	.mobile-full {
		padding: 6px 12px;
		border-radius: 4px;
		.overText {
			justify-content: center;
		}
	}

	.file-container {
		background: var(--color-white, #ffffff);
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 10px;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		overflow: hidden;

		.user-name {
			background: var(--bg-bgw1, #f3f4f8);
			border-radius: 100px;
			padding: 4px 8px 4px 8px;
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.name {
				color: var(--font-dgrey, #4d4d4d);
				text-align: left;
				font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b5-font-size, 12px);
				line-height: var(--b5-line-height, 22px);
				letter-spacing: var(--b5-letter-spacing, -0.02em);
				font-weight: var(--b5-font-weight, 400);

				/* 성명(ID) — 아이디는 한 톤 연하게 */
				.idf {
					color: var(--color-grey-l, #83868a);
					margin-left: 1px;
				}
			}
		}
	}

	.task-label-btn {
		min-height: 40px !important;
		gap: 14px;
	}

	.member-buttons {
		flex: 1;
		> * {
			flex: 1;
		}
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	padding: 20px;
	.task-label-btn {
		min-height: 50px !important;
	}
`;
const desktopStyles = (0, styled_components_1.css) ``;
async function readableStreamToBlob(readableStream) {
    const reader = readableStream.getReader();
    const chunks = [];
    let done = false;
    while (!done) {
        const { value, done: streamDone } = await reader.read();
        if (value) {
            chunks.push(value);
        }
        done = streamDone;
    }
    return new Blob(chunks);
}
exports.DSTT007_Detail = react_1.default.memo(({ id, isRegist = false, isModify = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const titleRef = (0, react_1.useRef)(null);
    const { isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [item, setItem] = react_1.default.useState({});
    const [title, setTitle] = react_1.default.useState('');
    const [publicValue, setPublicValue] = react_1.default.useState('');
    const [startDate, setStartDate] = react_1.default.useState('');
    const [startTime, setStartTime] = react_1.default.useState('');
    const [endDate, setEndDate] = react_1.default.useState('');
    const [endTime, setEndTime] = react_1.default.useState('');
    const [registFile, setRegistFile] = react_1.default.useState([]);
    const [keepMediaList, setKeepMediaList] = react_1.default.useState();
    // 일부 공개 시청자. 서버 allowed_viewers(id·name·idf) 그대로 보관 — 화면에는 "성명(ID)" 로 표시
    const [members, setMembers] = react_1.default.useState();
    const [previewId, setPreviewId] = react_1.default.useState(); //미리보기 아이디
    const [loading, setLoading] = react_1.default.useState(false);
    const [resultFileId, setResultFileId] = react_1.default.useState(); //다시보기 등록 - 파일 분할 업로드 시 id값
    const isDetail = isRegist === false && isModify === false ? true : false;
    const videoRef = (0, react_1.useRef)();
    const now = (0, react_1.useMemo)(() => (0, moment_1.default)(), []);
    const modifyReplayMutation = (0, react_query_1.useMutation)(server_1.postModifyReplay);
    const { data, refetch } = (0, server_1.useReplayList)({
        id,
        with_more_info: true,
    });
    const refetchList = (0, lodash_1.throttle)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        if (id) {
            title && dispatch((0, action_1.changeMobileMenuName)(title));
            refetchList();
            return;
        }
        setPublicValue('open');
        setStartDate(now.format('YYYY-MM-DD'));
        setStartTime(now.format('HH:mm'));
        setEndDate(now.format('YYYY-MM-DD'));
        setEndTime(now.format('HH:mm'));
    }, [id, isRegist, isModify]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('REPLAY_DETAIL_REFRESH', refetchList);
        return () => {
            APP.eventManager.unsubscribe('REPLAY_DETAIL_REFRESH', refetchList);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (id) {
            if (data) {
                const { items } = data;
                if (items.length > 0) {
                    const item = items[0];
                    if (item) {
                        if (titleRef.current)
                            titleRef.current.value = item.title;
                        setItem(item);
                        setTitle(item.title);
                        setPublicValue(item.status);
                        setStartDate((0, moment_1.default)(item.open_start_time).format('YYYY-MM-DD'));
                        setStartTime((0, moment_1.default)(item.open_start_time).format('HH:mm'));
                        setEndDate((0, moment_1.default)(item.open_end_time).format('YYYY-MM-DD'));
                        setEndTime((0, moment_1.default)(item.open_end_time).format('HH:mm'));
                        setMembers(item?.allowed_viewers);
                        // 서버 allowed_viewers 는 현재 id·name 만 내려온다(스웨거엔 idf 있음) — 멤버 API 로 아이디를 보충해
                        // 상세·수정 화면에서도 "성명(ID)" 로 보이게 한다. 사용자가 그 사이 목록을 바꿨으면 덮어쓰지 않는다.
                        const viewers = item?.allowed_viewers ?? [];
                        const missing = viewers.filter(viewer => !viewer.idf).map(viewer => viewer.id);
                        if (missing.length > 0) {
                            (0, server_1.getMembersByIds)(missing, item.class_id)
                                .then(found => {
                                const idfById = new Map(found.map(member => [member.id, member.identifier]));
                                setMembers(prev => prev &&
                                    prev.length === viewers.length &&
                                    prev.every((member, idx) => member.id === viewers[idx]?.id)
                                    ? prev.map(member => ({
                                        ...member,
                                        idf: member.idf || idfById.get(member.id) || undefined,
                                    }))
                                    : prev);
                            })
                                .catch(err => console.warn('[DSTT007] 시청자 아이디 보충 실패', err));
                        }
                        setKeepMediaList(item.medias.map(media => media.id));
                        return;
                    }
                }
            }
            setItem(undefined);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        dispatch((0, action_1.changeMobileMenuName)(title));
    }, [title]);
    (0, react_1.useEffect)(() => {
        if (videoRef.current) {
            videoRef.current.src = undefined;
            videoRef.current.controls = false;
        }
        if (previewId) {
            setLoading(true);
            (0, functions_1.fetchVideoUrl)(id, previewId).then(async (videoStream) => {
                try {
                    videoRef.current.src = `/api/media/v1/medias/${previewId}/source`;
                    videoRef.current.controls = true;
                    videoRef.current.play();
                    setLoading(false);
                }
                catch (error) {
                    alert('비디오를 로드하는 동안 오류가 발생했습니다. - 리소스에 없는 파일입니다. ');
                    console.error('비디오를 로드하는 동안 오류가 발생했습니다:', error);
                }
            });
        }
    }, [previewId]);
    const previousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'list',
            id: undefined,
        });
    };
    const modifyPage = () => {
        dispatch((0, action_1.updateMenu)(undefined, { menu: 'replay', detail: 'modify' }, id));
    };
    const openMemberList = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DSTT007_Detail_Child_1.WatchMember,
            componentProps: {
                members,
                setMembers,
            },
            width: isMobile && 400,
            height: 'unset',
            title: '참여자 추가',
        });
    };
    // 참여자 엑셀 일괄 등록 — 대상 인원이 많을 때 개별 추가 대신 아이디 목록 파일로 한 번에 추가
    const openMemberExcel = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DSTT007_Detail_Child_1.WatchMemberExcel,
            componentProps: {
                members,
                setMembers,
            },
            width: isMobile ? 400 : 560,
            height: 'unset',
            title: '참여자 엑셀 일괄 등록',
        });
    };
    const onSubmit = async () => {
        try {
            APP.eventManager.publish('SHOW_LOADING', true);
            const choiceMember = members?.map(member => member.id);
            const files = registFile.map(file => ({
                name: file.name,
                size: file.size,
            }));
            if (!id && isModify)
                throw new Error('id가 없습니다.');
            const response = await modifyReplayMutation.mutateAsync({
                id: isModify ? id : resultFileId,
                data: {
                    class_id: (0, classes_1.getClassesId)(),
                    //...(isModify ? { files: files } : {}),
                    title: title,
                    // 월/주차 구분은 사용하지 않는다(2026-09 운영 요청) — round/year/month 미전송
                    open_type: publicValue,
                    open_start_time: (0, moment_1.default)(`${startDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ssZ'),
                    open_end_time: (0, moment_1.default)(`${endDate} ${endTime}`).format('YYYY-MM-DDTHH:mm:ssZ'),
                    viewer_user_id: choiceMember && choiceMember.map(member => member),
                    ...(keepMediaList ? { media_id: keepMediaList } : {}),
                },
            });
            if (response) {
                setTimeout(() => {
                    dispatch((0, action_1.updateMenu)(undefined, { menu: 'replay', detail: 'detail' }, isModify ? id : resultFileId));
                    APP.eventManager.publish('SHOW_LOADING', false);
                }, 1000);
            }
        }
        catch (err) {
            APP.eventManager.publish('SHOW_LOADING', false);
            console.log('err');
            alert(err);
        }
        finally {
        }
    };
    const renderReplayInfoTitle = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(common_1.InputElement, { ref: titleRef, type: "text", onChange: setTitle, isDisable: isRegist ? false : true, style: {
                background: Colors_1.Colors.white,
            } }));
    }, [isRegist, setTitle]);
    const renderReplayInfo = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: 'repalyInfo', className: "title-info", style: { flex: 'unset' } },
        react_1.default.createElement("div", { className: "field-short title-wrap" },
            react_1.default.createElement("div", { className: "field-global-001" },
                !isMobile && (react_1.default.createElement("div", { className: "task-label" }, t('conference.title'))),
                react_1.default.createElement("div", { className: "fext-field" }, isMobile ? (react_1.default.createElement("div", { className: "replay-info-wrap" },
                    react_1.default.createElement("div", { className: "task-label" }, t('conference.title')),
                    renderReplayInfoTitle)) : (renderReplayInfoTitle)))),
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('conference.settingPublic')),
            react_1.default.createElement("div", { className: "fext-field", style: { gap: 14 } },
                react_1.default.createElement(DSTT007_Detail_Child_1.SetPublicRadio, { isDisable: isRegist ? false : true, defaultPublic: item?.status, handlerChange: setPublicValue }))),
        publicValue !== 'hide' && (react_1.default.createElement("div", { className: "field-global-001 date-wrap" },
            react_1.default.createElement("div", { className: "task-label" }, t('conference.publicDate')),
            isMobile ? (react_1.default.createElement("div", { className: "replay-info-wrap", style: { flexDirection: 'column' } },
                react_1.default.createElement("div", { className: "fext-field", style: { gap: 14 } },
                    react_1.default.createElement(common_1.InputElement, { type: "date", value: startDate, onChange: setStartDate, isDisable: isRegist ? false : true, min: now.format('YYYY-MM-DD'), style: {
                            background: Colors_1.Colors.white,
                        } }),
                    react_1.default.createElement(common_1.InputElement, { type: "time", value: startTime, isDisable: isRegist ? false : true, onChange: setStartTime, style: {
                            background: Colors_1.Colors.white,
                        } })),
                react_1.default.createElement("div", { className: "fext-field", style: { gap: 14 } },
                    react_1.default.createElement(common_1.InputElement, { type: "date", value: endDate, onChange: setEndDate, isDisable: isRegist ? false : true, min: now.format('YYYY-MM-DD'), style: {
                            background: Colors_1.Colors.white,
                        } }),
                    react_1.default.createElement(common_1.InputElement, { type: "time", value: endTime, isDisable: isRegist ? false : true, onChange: setEndTime, style: {
                            background: Colors_1.Colors.white,
                        } })))) : (react_1.default.createElement("div", { className: "fext-field", style: { gap: 14 } },
                react_1.default.createElement(common_1.InputElement, { type: "date", value: startDate, onChange: setStartDate, isDisable: isRegist ? false : true, min: now.format('YYYY-MM-DD'), style: {
                        background: Colors_1.Colors.white,
                    } }),
                react_1.default.createElement(common_1.InputElement, { type: "time", value: startTime, isDisable: isRegist ? false : true, onChange: setStartTime, min: now.format('HH:mm'), style: {
                        background: Colors_1.Colors.white,
                    } }),
                react_1.default.createElement(common_1.InputElement, { type: "date", value: endDate, onChange: setEndDate, isDisable: isRegist ? false : true, min: now.format('YYYY-MM-DD'), style: {
                        background: Colors_1.Colors.white,
                    } }),
                react_1.default.createElement(common_1.InputElement, { type: "time", value: endTime, isDisable: isRegist ? false : true, onChange: setEndTime, min: now.format('HH:mm'), style: {
                        background: Colors_1.Colors.white,
                    } }))))),
        publicValue === 'open_partial' && (react_1.default.createElement("div", { className: "field-global-001 member-wrap" },
            react_1.default.createElement("div", { className: "task-label task-label-btn", style: { flexDirection: 'row' } },
                react_1.default.createElement("p", null, t('conference.invite')),
                !isDetail && (react_1.default.createElement("div", { className: "member-buttons" },
                    react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'mobile-full' : 'xmd'}`, text: "\uCC38\uC5EC\uC790 \uCD94\uAC00", onClick: openMemberList }),
                    react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'mobile-full' : 'xmd'}`, text: "\uC5D1\uC140 \uC77C\uAD04 \uB4F1\uB85D", onClick: openMemberExcel })))),
            react_1.default.createElement("div", { className: "fext-field", style: { gap: 14 } }, members && (react_1.default.createElement("div", { className: "file-container" }, members && members.length <= 0 ? (react_1.default.createElement("div", null, " \uC2DC\uCCAD \uAC00\uB2A5\uD55C \uC0AC\uC6A9\uC790\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.")) : (members.map(member => {
                return (react_1.default.createElement("div", { key: member.id, className: "member user-name" },
                    react_1.default.createElement("span", { className: "name" },
                        member.name,
                        member.idf && react_1.default.createElement("span", { className: "idf" },
                            "(",
                            member.idf,
                            ")")),
                    react_1.default.createElement(common_1.Button, { className: "xsm", option: {
                            buttonAfterIcon: {
                                show: isDetail ? false : true,
                                name: 'close',
                                color: Colors_1.Colors.accent,
                                size: 16,
                            },
                        }, onClick: () => {
                            setMembers(members.filter(m => m.id !== member.id));
                        } })));
            }))))))))), [
        isModify,
        item,
        isRegist,
        publicValue,
        members,
        startDate,
        startTime,
        endDate,
        endTime,
    ]);
    const renderReplayTable = (0, react_1.useMemo)(() => (react_1.default.createElement(DSTT007_Detail_Child_1.RegistFileTable, { id: id, key: 'repalyTable', isRegist: isRegist, medias: item?.medias, previewId: previewId, setPreviewId: (id) => {
            !loading && setPreviewId(id);
        }, setRegistFile: setRegistFile, setKeepMediaList: setKeepMediaList, setResultFileId: setResultFileId, isModify: isModify, keepMediaList: keepMediaList })), [
        id,
        isRegist,
        isModify,
        item?.medias,
        previewId,
        loading,
        setPreviewId,
        setRegistFile,
        setKeepMediaList,
        keepMediaList,
    ]);
    const rednerVideo = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: 'video' }, !isRegist ? (react_1.default.createElement("div", { className: "video-area", style: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        } },
        react_1.default.createElement("video", { ref: videoRef, src: previewId
                ? `/api/media/v1/medias/${id}/source?media_id=${previewId}`
                : '', disablePictureInPicture: true, controlsList: "nodownload", onContextMenu: e => e.preventDefault() }),
        loading && react_1.default.createElement("div", { className: "loading" }, "\uB85C\uB529\uC911..."),
        react_1.default.createElement("div", { className: "txt" }, "\uBBF8\uB9AC\uBCF4\uAE30"))) : null)), [videoRef, previewId, loading, id, isRegist]);
    // 일부 공개인데 공개 대상자가 0명이면 시청 이력은 빈 목록 + '등록된 대상자가 없습니다.'
    // 다시보기 정보(공개 설정·대상자)를 받은 뒤에 목록을 그린다 — 먼저 그리면 이력 조회가 앞서 나가
    // 대상자 0명인데도 이력 행이 잠깐 보일 수 있다.
    const isItemLoaded = Boolean(item?.id);
    const noWatchTarget = isItemLoaded && publicValue === 'open_partial' && (members?.length ?? 0) === 0;
    const renderWatchHistoryTable = (0, react_1.useMemo)(() => !isRegist && isItemLoaded && react_1.default.createElement(DSTT007_Detail_Child_1.WatchHistoryTable, { key: id, id: id, noTarget: noWatchTarget }), [id, isRegist, isItemLoaded, noWatchTarget]);
    const renderDetailInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(layout_1.DetailTitleInfo
    // title={t('conference.replay')}
    , { 
        // title={t('conference.replay')}
        title: `${t('conference.replay')} ${isRegist
            ? isModify
                ? t('common.modify')
                : t('common.regist')
            : t('common.detail')}`, previousPage: previousPage })), [isRegist, isModify]);
    const renderButton = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: 'button', style: isMobile ? { display: 'flex', justifyContent: 'flex-end' } : {} }, !isRegist ? (react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'sm' : 'xmd'}`, text: t('common.modify'), onClick: modifyPage })) : (react_1.default.createElement("div", { className: "btn-container" },
        react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'sm' : 'xmd'}`, text: t('common.cancel'), onClick: previousPage }),
        react_1.default.createElement(common_1.Button, { className: `btn_default ${isMobile ? 'sm' : 'xmd'}`, text: t('common.okay'), onClick: onSubmit }))))), [
        isRegist,
        isModify,
        registFile,
        title,
        publicValue,
        startDate,
        startTime,
        endDate,
        endTime,
        members,
        keepMediaList,
    ]);
    if (isMobile) {
        return (react_1.default.createElement(DSTT007_DetailStyled, { className: "dst007-detail", "$isRegist": isRegist, "$isTablet": isTablet, "$isMobile": isMobile },
            react_1.default.createElement(layout_1.MobileTabLayout, { tabList: [
                    {
                        id: 1,
                        title: '자세히보기',
                        component: [
                            renderReplayInfo,
                            renderReplayTable,
                            rednerVideo,
                            renderWatchHistoryTable,
                            renderButton,
                        ],
                        styles: { gap: '24px', display: 'flex', flexDirection: 'column' },
                    },
                ], hideHr: true })));
    }
    return (react_1.default.createElement(DSTT007_DetailStyled, { className: "dst007-detail wrapper-padding", "$isRegist": isRegist, "$isTablet": isTablet, "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "dst007-container" },
            react_1.default.createElement("div", { className: "left-wrap" },
                isDesktop && renderDetailInfo,
                react_1.default.createElement("div", { className: "title-info" },
                    renderReplayInfo,
                    isTablet ? (react_1.default.createElement(react_1.default.Fragment, null,
                        renderReplayTable,
                        rednerVideo)) : (react_1.default.createElement("div", { className: "field-short" },
                        renderReplayTable,
                        rednerVideo))),
                renderWatchHistoryTable,
                renderButton))));
});
